import { EmptyState } from '@Components/EmptyState';
import { ListSkeleton, Skeleton } from '@Components/Skeleton';
import { LAYER_HEIGHT, MARKER_OVERHANG } from '@Pages/Pacing/components/PacingBar';

const PACING_ROW_HEIGHT = LAYER_HEIGHT + 2 * MARKER_OVERHANG;
const SKELETON_PADDING = 16;

// Placeholder rows while a pane's data loads (Streaming Pacing's RowsSkeleton). Clearance and
// forecast rows are taller, so they pass their own row height.
export const RowsSkeleton = ({ rowHeight = PACING_ROW_HEIGHT }: { rowHeight?: number }) => (
  <div className='pacing-skeleton'>
    <Skeleton>
      <ListSkeleton
        lineHeight={rowHeight}
        lineSpacing={SKELETON_PADDING}
        horizontalPadding={SKELETON_PADDING}
        verticalPadding={SKELETON_PADDING}
        alignTop
        borderRadius={8}
      />
    </Skeleton>
  </div>
);

// Shown in place of a pane whose fetch failed, so it doesn't load forever behind the error modal.
export const LoadFailedState = () => (
  <EmptyState
    title='Unable to load pacing data'
    subtitle='Try changing the date range or refreshing the page.'
  />
);
